import { memo } from "react";
import styles from "./GridSearchBar.module.scss";
import { SearchIcon } from "../../../assets/icons";

type Props = {
	placeholder: string;
	width: string;
	onChangeHandler: (searchText: string) => void;
	onKeyDownHandler?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

const GridSearchBar: React.FC<Props> = memo((props: Props) => {
	return (
		<div className={styles.searchBar} style={{ width: props.width }}>
			<SearchIcon />
			<input placeholder={props.placeholder} onKeyDown={props?.onKeyDownHandler} onChange={e => props.onChangeHandler(e.target.value)}></input>
		</div>
	);
});

export default GridSearchBar;
